import { apiRequestBase } from "./client";
import { env } from "../config/env";

export const categoryApi = {
  getCategories: async () => {
    const response = await apiRequestBase<any>(
      env.itemBaseUrl,
      "/Category/SelectList?FetchAll=true",
      {
        method: "GET",
      },
    );
    return response?.data ?? [];
  },
};
